import Carousel from "../../carousel/Carousel";
import {emojiByGroupId} from "./emojiByGroupId";
import React from "react";
import {PresetGroupProps} from "../../../types/PresetProps";

interface GroupSectionProps {
    presetGroups: PresetGroupProps[];
    onSelectGroup: (groupId: number) => void;
    selectedGroupId?: number | null;
}

const GroupSection = ({ presetGroups, onSelectGroup, selectedGroupId }: GroupSectionProps) => {
    return (
        <div className="section">
            <div className="sub-title">What kind of vibe would your clients like in your messages?</div>
            <Carousel selectedId={selectedGroupId} id="groups-carousel" maxItemsPerView={5} onChange={(id: number) => onSelectGroup(id)}
                      items={presetGroups?.map(presetGroup => ({
                          id: presetGroup.id,
                          title: presetGroup.title,
                          description: presetGroup.shortDescription,
                          icon: emojiByGroupId(presetGroup.id),
                      })) || []}/>
        </div>
    );
}

export default GroupSection;